const camel2Snake = (str) => {
  return str.replace(/([A-Z])/g, function(x, y) { return "_" + y.toLowerCase() }).replace(/^_/, "");
}

export {
  camel2Snake
}